import {useLocation} from 'react-router-dom';
import useRemoteTranslations from './useRemoteTranslations';
import {isProductPath} from './productLanguageBoundary';
export default function ProductTranslationRuntime() {
    const {pathname} = useLocation();
    let signedIn = false;
    try {signedIn = Boolean(window.localStorage.getItem('token'));} catch (_) {}
    useRemoteTranslations({enabled: isProductPath(pathname, signedIn)});
    return null;
}
